<div class="app-wrapper" *ngIf="versionInfoObserver | async as version">
    <div class="main">
        <div class="grid grid-nogutter p-fluid">
            <div class="col-12 grid grid-nogutter card justify-content-center nav-bar">
                <div class="grid" [ngStyle]="{width: '1300px'}">
                    <div class="col-6 flex align-items-center">
                        <img src="https://klinikaikozpont.unideb.hu/themes/custom/unideb_gamma/logo.svg" height="100px" (click)="logoClicked()">
                        <div class="slideshow-button-container">
                            <h5 class="m-0">Debreceni Egyetem</h5>
                            <h4 class="m-0">Katasztrófaorvosi és Karitatív Koordinációs Központ</h4>
                        </div>
                    </div>
                    <!--div class="col-5"></div-->
                    @if ((isUserLoggedIn | async) && currentUserInfo?.name) {
                        <div class="col-6 text-center align-content-center pr-4">
                            <p-speeddial [model]="profileOptions" direction="down"  [ngStyle]="{width: 'auto', float: 'right', marginTop: '10px'}">
                                <ng-template #button let-toggleCallback="toggleCallback">
                                    <button pButton class="white-space-nowrap text-overflow-ellipsis overflow-hidden"
                                            (click)="toggleCallback($event)"
                                            [label]="currentUserInfo?.displayName"
                                            [ngStyle]="{maxWidth: '325px'}"></button>
                                </ng-template>
                                <ng-template #item let-item let-toggleCallback="toggleCallback">
                                    <button class="p-button-outlined" pButton [label]="item.label" [icon]="item.icon"
                                            (click)="toggleCallback($event, item)"></button>
                                </ng-template>
                            </p-speeddial>
                        </div>
                    } @else {
                        <div class="col-6 text-center align-content-center pr-4">
                            <button pButton icon="pi pi-sign-in" label="Bejelentkezés"
                                    [ngStyle]="{width: 'auto', float: 'right'}" (click)="navigateToLogin()"></button>
                        </div>
                    }
                </div>
            </div>
        </div>
        <app-primeng-service-handler></app-primeng-service-handler>
        <router-outlet></router-outlet>
    </div>
    <footer>
        <span class="mx-1">Booking4K(Kliens: {{version.frontend}}, Szerver: {{version.backend}})</span>
        <span class="mx-1"><a class="link-button underline cursor-pointer" (click)="openDocument()">Felhasználói kézikönyv</a></span>
        <span class="mx-1 text-right">Sightspot Network Kft.</span>
    </footer>
</div>
